/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateInformationBannerDto { 
    headLine?: string;
    descriptionText?: string;
    publishDateTime?: string;
    unPublishDateTime?: string;
    linkText?: string;
    linkRef?: string;
    context?: string;
}

